// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"523":"6976f6aa","766":"972f4cb9"}[chunkId] + ".css";
};